<template>
  <div
    :class="[
      'flex h-4 items-center justify-center rounded-full px-1.5 text-3xs font-semibold transition-all',
      isActive ? 'bg-gray-900 text-white' : 'bg-gray-200'
    ]"
  >
    {{ badge }}
  </div>
</template>

<script setup lang="ts">
defineProps<{ badge: Primitive; isActive?: boolean }>()
</script>
